import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "../pages/HomePage";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { buildCompleteHead } from "../utils/seo";
import { LangProvider } from "../contexts/LangContext";

export const Route = createFileRoute("/")({
  head: () => {
    const seoData = buildCompleteHead(
      "default",
      "home",
      "https://lotin.uz",
      "",
      "",
    );
    return {
      meta: [{ title: seoData.title }, ...seoData.meta],
      links: seoData.links,
      htmlProps: { lang: "uz-Latn" },
    };
  },
  component: Home,
});

function Home() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    // Guard for SSR: only call changeLanguage if it exists
    if (i18n?.changeLanguage) {
      i18n.changeLanguage("default");
    }
  }, [i18n]);

  return (
    <LangProvider lang={"uz-Latn"}>
      <HomePage />
    </LangProvider>
  );
}
